<script>
  import Acciones from "./Components/Acciones.svelte";

  import {format, parse} from 'date-fns';
  import {es} from 'date-fns/locale';
  import CampoDeClave from "./Components/UI/CampoDeClave.svelte";
  import Cabecera from "./Components/Cabecera.svelte";
  import Teclado from "./Components/UI/Teclado.svelte";
  import Caja from "../../assets/src/Components/UI/Caja.svelte";
  import Icono from "../../assets/src/Components/UI/Icono.svelte";
  import {onMount} from 'svelte';

  import {nombreCompleto} from '../../assets/src/Modelos/Trabajador';
  import Titulo from "../../assets/src/Components/UI/Titulo.svelte";
  import Horas from "../../assets/src/Components/Marcajes/Horas.svelte";
  import Subtitulo from "../../assets/src/Components/UI/Subtitulo.svelte";
  import instance from "./axios-control";

  let codigo = localStorage.codigo || '';
  let error = null;
  let posicion = null;
  let verClave = false;
  let resultado = null;
  let entradas = null;
  let salidas = null;
  let habilitado = false;

  onMount(() => {
    instance.get('motivos')
        .then(res => {
          const motivos = res.data.slice(2);
          entradas = motivos.filter(x => x.tipo === 'Actividad');
          salidas = motivos.filter(x => x.tipo === 'Ausencia');
        })
  });

  window.addEventListener('keydown', e => {
    if (e.key >= '0' && e.key <= '9') {
      codigo += e.key;
      e.preventDefault();
      e.stopPropagation();
    } else if (e.key === 'Backspace') {
      codigo = codigo.substring(0, codigo.length - 1);
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  $: habilitado = codigo.length >= 3;

  let marcajes = [];

  let controller = null;
  $: if (habilitado) {
    marcajes = [];

    instance.get(`hoy/${codigo}`)
        .then(datos => marcajes = datos.data.horas ? datos.data.horas : [])
        .catch(() => {
        });
  } else {
    marcajes = [];
  }

  const imputa = ({detail}) => {
    instance.post(`marcaje`, {codigo, tipo: detail, posicion, origen: 'Ordenador'})
        .then(res => {
          error = null;
          const fecha = parse(res.data.marcaje.fecha, 'yyyy-MM-dd', new Date());
          resultado = {
            ...res.data,
            marcaje: {
              ...res.data.marcaje,
              fecha: format(fecha, "d 'de' MMMM 'de' yyyy", {locale: es})
            }
          };

          localStorage.codigo = codigo;
        })
        .catch(e => {
          console.log(e);
          error = e;
        });
  };

  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(position => {
      posicion = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
    });
  }
</script>

<svelte:head>
    <title>Marcaje control de presencia</title>
</svelte:head>

<main>
    <Caja>
        <div slot="titulo">
            <Cabecera/>
        </div>

        {#if resultado}
            {#if resultado.marcaje.motivo.tipo === 'Actividad'}
                <Titulo margen={false}>Hola, {nombreCompleto(resultado.trabajador)}</Titulo>
            {:else}
                <Titulo margen={false}>Hasta luego, {nombreCompleto(resultado.trabajador)}</Titulo>
            {/if}

            <p>Has realizado correctamente una imputación de
                <strong>{resultado.marcaje.motivo.nombre.toLowerCase()}</strong>
                el <strong>{resultado.marcaje.fecha}</strong> a las
                <strong>{resultado.marcaje.hora}</strong>
            </p>

            <div class="icono">
                <Icono tamano={80}>check</Icono>
            </div>
        {:else if entradas && salidas}
            <div class="clave">
                <CampoDeClave valor={codigo} on:input={e => codigo = e.target.value}/>
            </div>

            {#if error}
                <div class="error">{error}</div>
            {/if}
            <Teclado on:tecla={e => codigo += e.detail } on:borrar={() => codigo = ''} />

            <Acciones {habilitado} {entradas} {salidas} {codigo} on:imputa={imputa}/>

            {#if marcajes.length}
                <div class="marcajes">
                    <div class="marcajes-titulo">
                        <Subtitulo>Marcajes de hoy</Subtitulo>
                    </div>

                    <div class="marcajes-lista">
                        {#each marcajes as marcaje}
                            <Horas {marcaje}/>
                        {/each}
                    </div>
                </div>
            {/if}
        {/if}
    </Caja>
</main>

<style>
    :global(:root) {
        --naranja: #ff6600;
        --blanco: #fffffc;
        --negro: #000;
        --naranja-clarito: #ffe0cc;
        --verde: #26A892;
        --rojo: #F5001D;
        --gris: #999999;

        --acentos: var(--naranja);
        --bordes: var(--naranja-clarito);
        --color-del-texto: var(--negro);
        --tamano-del-texto: 15px;
        --familia-del-texto: Roboto, sans-serif;
        --familia-monoespaciada: 'Roboto Mono', monospace;

        --padding-global: 1em;
        --ancho: 90rem;
        --alto-de-linea: 1.5;
        --radio-global: 5px;

        --padding-vertical-botones: .5rem;
        --padding-horizontal-botones: .66rem;
    }

    :global(html) {
        box-sizing: border-box;
        color: var(--color-del-texto);
        overflow-y: scroll;
        overflow-x: hidden;
    }

    :global(html, body) {
        margin: 0;
        padding: 0;
        font-size: var(--tamano-del-texto);
        font-family: var(--familia-del-texto);
        line-height: var(--alto-de-linea);
    }

    :global(h1, h2, h3) {
        font-family: var(--familia-del-texto);
    }

    main {
        width: 90%;
        max-width: 450px;
        margin: 1em auto;
        min-height: 100vh;
        display: flex;
        align-items: center;
    }

    .clave {
        max-width: 15em;
        margin: 0 auto;
    }

    .error {
        margin: 1em 0;
        color: var(--acentos);
        text-align: center;
        font-size: 1.2em;
    }

    .icono {
        text-align: center;
        --color-icono: var(--verde);
    }

    .marcajes {
        margin-top: 1em;
    }

    .marcajes-titulo {
        margin-bottom: .5em;
    }
</style>